import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "login-wrapper" }
const _hoisted_2 = { class: "flex-grow-1 d-flex flex-column align-center justify-center" }
const _hoisted_3 = { class: "full-width" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-center justify-center flex-wrap" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-h4 text-center py-2 pt-4 font-weight-bold secondary--text" }, " Internal User Sign in ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_auth_hero = _resolveComponent("auth-hero")!
  const _component_login_form = _resolveComponent("login-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_auth_hero),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_login_form)
      ])
    ])
  ]))
}